import { render, staticRenderFns } from "./CalendarMaster.vue?vue&type=template&id=b0852c10"
import script from "./CalendarMaster.ts?vue&type=script&lang=ts&external"
export * from "./CalendarMaster.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports